import { BasicNumberInput } from '@hub/common/BasicNumberInput/BasicNumberInput';
import { IbhEventCategory, TrackedIbhEventActions } from '@hub/bearing-hub/common/tracking.config';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { usePiwikPro } from '@piwikpro/next-piwik-pro';
import { useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

type QuantityInputProps = {
  initialQuantity: number;
  onQuantityChange: (value?: number) => void;
};
export const QuantityInput = ({ initialQuantity, onQuantityChange }: QuantityInputProps) => {
  const { t } = useTranslation('bearing-hub/bearingHub');
  const router = useRouter();
  const { CustomEvent } = usePiwikPro();
  const [inputValue, setInputValue] = useState(initialQuantity.toString());
  const parsedInputValue = Number(inputValue);
  const orderQuantityLabelKey =
    inputValue !== '' && parsedInputValue > 1
      ? 'FILTERS.PLACEHOLDER.ORDER_QUANTITY_PLURAL'
      : 'FILTERS.PLACEHOLDER.ORDER_QUANTITY';
  const quantityText = t(orderQuantityLabelKey);

  const debouncedOnQuantityChange = useDebouncedCallback((value: string) => {
    if (value === '' || Number(value) <= 0) {
      onQuantityChange(initialQuantity);
    } else {
      const quantity = Number(value);
      onQuantityChange(quantity);
    }
  }, 500);

  return (
    <div className="lg:w-60" data-testid="dimension-input-quantity">
      <label
        title={quantityText}
        id="filter_label_surface_pressure"
        htmlFor="filter_quantity"
        className="block mb-2 truncate text-sm"
      >
        <b>{quantityText}</b>
      </label>
      <div className="relative">
        <BasicNumberInput
          id="filter_quantity"
          placeholder={quantityText}
          onlyInt
          value={inputValue}
          validator={value => Number(value) > 0}
          onChange={value => {
            setInputValue(value);

            if (router.isReady) {
              CustomEvent.trackEvent(IbhEventCategory, TrackedIbhEventActions.quantity, value);
              debouncedOnQuantityChange(value);
            }
          }}
        />
      </div>
    </div>
  );
};
